var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-application',[(_vm.autenticado)?[_c('Header',{on:{"toggle":_vm.handleToggle}}),_c('Sidebar',{attrs:{"open":_vm.open}}),_c('rkm-main',{attrs:{"open":_vm.open}},[_vm._t("default")],2)]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }